/** Max Markdown UTF-8 payload size for PDF requests and local file open. */
export const maxMarkdownBytes = 2 * 1024 * 1024;
export const maxPdfRequestBodyBytes = maxMarkdownBytes + 64 * 1024;
